import { useState, useMemo, useRef } from "react"
import { useRequest } from "ahooks";
import { Card, Button } from "antd";
import { Table } from "./../../components/table";
import { generateTableColumns } from "./config";
import { CommonServer } from "./../../server";
import { Operation } from "./operation";
import { langCommon } from "../../locales";

const server = CommonServer.Level

export const Level = () => {
    const operationRef: any = useRef();

    const [loading, setLoading] = useState<boolean>(false);
    const [tableData, setTableData] = useState<any[]>([]);

    //获取表格数据
    const { refresh } = useRequest(server.list, {
        onBefore: () => setLoading(true),
        onFinally: () => setLoading(false),
        onError: () => setTableData([]),
        onSuccess: (res: any) => {
            setTableData(res);
        }
    });

    const getTableColumns = useMemo(() => {
        return generateTableColumns({ operationRef, loading, setLoading, refresh });
    }, [operationRef, loading, setLoading, refresh]);

    return (
        <div>
            <Card className="mt20">
                <div className="flex flex-end mb20">
                    <Button className="ml10" type="primary" onClick={() => operationRef.current?.changeVisible(true, 'create')}>{langCommon?.create}</Button>
                </div>
                <Table
                    loading={loading}
                    dataSource={tableData}
                    columns={getTableColumns}
                    rowKey="Id"
                    scroll={{
                        x: 'max-content'
                    }}
                    page={false}
                />
            </Card>
            <Operation ref={operationRef} onSuccess={refresh} />
        </div>
    );
}